import heroHeadingSvg from '@plone/volto/icons/hero.svg';
import Edit from './Edit';
import View from './View';

export const heroHeadingBlock = {
  id: 'junts_hero_heading',
  title: 'Hero Heading',
  icon: heroHeadingSvg,
  group: 'common',
  view: View,
  edit: Edit,
  restricted: false,
  mostUsed: true,
  sidebarTab: 1,
  blockHasOwnFocusManagement: true,
};
